import { flex } from "../../../enums";
export var getPaddingClassNames = function getPaddingClassNames(_temp) {
  var _ref2;

  var _ref = _temp === void 0 ? {} : _temp,
      all = _ref.all,
      left = _ref.left,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;

  return _ref2 = {}, _ref2["padding-" + all] = all, _ref2["padding-left-" + left] = left, _ref2["padding-right-" + right] = right, _ref2["padding-top-" + top] = top, _ref2["padding-bottom-" + bottom] = bottom, _ref2;
};
export var getMarginClassNames = function getMarginClassNames(_temp2) {
  var _ref4;

  var _ref3 = _temp2 === void 0 ? {} : _temp2,
      all = _ref3.all,
      left = _ref3.left,
      right = _ref3.right,
      top = _ref3.top,
      bottom = _ref3.bottom;

  return _ref4 = {}, _ref4["margin-" + all] = all, _ref4["margin-left-" + left] = left, _ref4["margin-right-" + right] = right, _ref4["margin-top-" + top] = top, _ref4["margin-bottom-" + bottom] = bottom, _ref4;
};
export var getFlexChildClassNames = function getFlexChildClassNames(_temp3) {
  var _ref6;

  var _ref5 = _temp3 === void 0 ? {} : _temp3,
      basis = _ref5.basis,
      grow = _ref5.grow,
      shrink = _ref5.shrink;

  return _ref6 = {}, _ref6["flex-basis-" + basis] = basis, _ref6["flex-grow-" + grow] = grow, _ref6["flex-shrink-" + shrink] = shrink, _ref6;
};
export var getFlexClassNames = function getFlexClassNames(_temp4) {
  var _ref8;

  var _ref7 = _temp4 === void 0 ? {} : _temp4,
      display = _ref7.display,
      align = _ref7.align,
      justify = _ref7.justify,
      direction = _ref7.direction,
      flow = _ref7.flow,
      gap = _ref7.gap;

  var isInlineFlex = display === flex.display.INLINE_FLEX;
  var isFlex = display === flex.display.FLEX;
  var shouldForceFlex = !isInlineFlex && (align || justify || direction || flow || gap);
  return _ref8 = {
    flex: isFlex || shouldForceFlex,
    'in-flex': isInlineFlex
  }, _ref8["align-" + align] = align, _ref8["justify-" + justify] = justify, _ref8["direction-" + direction] = direction, _ref8["flow-" + flow] = flow, _ref8["gap-" + gap] = gap, _ref8;
};
export var getHeightClassNames = function getHeightClassNames(_ref9) {
  var _ref10;

  var value = _ref9.value,
      max = _ref9.max,
      min = _ref9.min;
  return _ref10 = {}, _ref10["height-" + value] = value, _ref10["height-max-" + max] = max, _ref10["height-min-" + min] = min, _ref10;
};
export var getWidthClassNames = function getWidthClassNames(_ref11) {
  var _ref12;

  var value = _ref11.value,
      max = _ref11.max,
      min = _ref11.min;
  return _ref12 = {}, _ref12["width-" + value] = value, _ref12["width-max-" + max] = max, _ref12["width-min-" + min] = min, _ref12;
};
//# sourceMappingURL=utils.js.map